import { defineMessages } from "react-intl";

export const messages = defineMessages({
    title: {
        id: "UsageBasedPricing.PageHeader.title",
        defaultMessage: "Calculate your capacity"
    },
    subtitle: {
        id: "UsageBasedPricing.PageHeader.subtitle",
        defaultMessage:
            "Understand how much capacity you need based on the features and scale of your organization"
    }
});
